export const ID_VARIANT_SIZE = '3eea3737-0cf2-11ee-0a80-03670030dd78';
